module.exports = __webpack_public_path__ + "static/media/header.881ed451.mp3";